import classNames from "classnames"
import styles from "./SText.module.scss"
import { CSSProperties, FC, ReactNode } from "react"


interface STextProps {
  className?: string
  variant: "title" | "label" | "body" |"bodySmall" | "error" | "titleSmall"| "titleMedium"| "titleLarge" | "headlineSmall"| "headlineMedium"| "headlineLarge"
  color?:
    | "green200"
    | "green300"
    | "green400"
    | "green500"
    | "turq300"
    | "turq400"
    | "turq500"
    | "white"
    | "o500"
    | "r400"
    | "r500"
    | "r600"
    | "mono1_300"
    | "mono1_400"
    | "mono2_300"

  children: ReactNode
  htmlFor?: string
  style?: CSSProperties
  size?: number
  title?: string

  [key: string]: unknown
}

const SText: FC<STextProps> = ({ className, variant, color, size, children, htmlFor, style, title, ...other }) => {
  const textStyle = !!size ? { fontSize: size, ...style } : { ...style }

  if (variant == "title") {
    return (
      <h1
        title={title}
        className={classNames(className, styles[variant], !!color && styles[color])}
        style={textStyle}
        {...other}
      >
        {children}
      </h1>
    )
  }
  if (variant == "headlineLarge") {
    return (
      <h2
        title={title}
        className={classNames(className, styles[variant], !!color && styles[color])}
        style={textStyle}
        {...other}
      >
        {children}
      </h2>
    )
  }if (variant == "headlineMedium") {
    return (
      <h2
        title={title}
        className={classNames(className, styles[variant], !!color && styles[color])}
        style={textStyle}
        {...other}
      >
        {children}
      </h2>
    )
  }

  if (!!htmlFor) {
    return (
      <label
        htmlFor={htmlFor}
        className={classNames(className, styles[variant], !!color && styles[color])}
        title={title}
        style={textStyle}
        {...other}
      >
        {children}
      </label>
    )
  } else {
    return (
      <span
        title={title}
        className={classNames(className, styles[variant], !!color && styles[color])}
        style={textStyle}
        {...other}
      >
        {children}
      </span>
    )
  }
}
export default SText
